import { Injectable, signal } from '@angular/core';
import { ToastType } from '../model/store';

/** Toast queue. A signal, so the app shell re-renders when a toast arrives or times out (zoneless). */
@Injectable({
  providedIn: 'root'
})
export class ToastService {
  readonly toasts = signal<Toast[]>([]);

  show(message: string, type: ToastType = ToastType.SUCCESS, duration = 3000) {
    this.toasts.update(list => {
      const next = [...list, { message, type }];
      return next.length > 3 ? next.slice(1) : next;
    });
    setTimeout(() => this.toasts.update(list => list.slice(1)), duration);
  }

  remove(index: number) {
    this.toasts.update(list => list.filter((_, i) => i !== index));
  }
}

export interface Toast {
  message: string
  type: ToastType
}
